import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError, } from 'rxjs/operators';

import {
    CREATE_NEW_ACCOUNT,
    CREATE_NEW_ACCOUNT_SUCCESS,
    CREATE_NEW_ACCOUNT_FAILED
} from '../../constants';


const createNewAccount = (action$, state$) =>
  action$.pipe(
    ofType(CREATE_NEW_ACCOUNT),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/admin/account`,
        headers: {
          Authorization: `Bearer ${state$.value.auth.LIPToken}`,
        },
        responseType: 'json',
        body: JSON.stringify(action.payload),
        crossDomain: true,
        method: 'POST',
      }).pipe(
        map(response => {
            console.log(response)
          return {
            type: CREATE_NEW_ACCOUNT_SUCCESS,
          };
        }),
        catchError(error =>
          of({
            type: CREATE_NEW_ACCOUNT_FAILED,
            error,
          })
        )
      )
    )
  );

export default createNewAccount;
